import {getDicts, getPlaces} from '@/api/monitoring'
import {getOkpd2Json} from '@/api/order';
import {flatTree, flatDict, hasValue} from '@/utils/obj'

const SET_STATE = 'SET_STATE';

/*places: {
    _root_: [],
    _levels_: { 1: [], 2: [], 3: [], },
    "12": { name: 'Чебоксары', parent: '1', child: [] }
  },*/

const defaultState = {
  // все уровни субьектов
  places: null,
  loadingPlaces: false,

  // регионы
  regs: null,
  loadingRegs: false,

  // города
  cities: null,
  loadingCities: false,

  // способы закупки
  purchaseMethods: null,
  loadingPurchaseMethods: false,

  // валюты
  currencyCodes: null,
  loadingCurrencyCodes: false,

  // площадки по категориям
  sections: null,
  loadingSections: false,

  // ОКПД2
  okpd2: null,
  loadingOkpd2: false
};

// 3 справочника грузятся 1 запросом
async function loadDicts({ state, commit }) {
  // игнорируем если справочники уже загружены или загружаются
  if (state.purchaseMethods || state.sections || state.currencyCodes) return;
  if (state.loadingPurchaseMethods || state.loadingSections || state.loadingCurrencyCodes) return;

  commit(SET_STATE, { loadingPurchaseMethods: true, loadingSections: true, loadingCurrencyCodes: true, });

  let data = await getDicts();

  if (state.purchaseMethods || state.sections || state.currencyCodes) return;
  commit(SET_STATE, {
    loadingPurchaseMethods: false,
    purchaseMethods: data.purchaseMethods,

    loadingSections: false,
    sections: flatTree(data.dictSections),

    loadingCurrencyCodes: false,
    currencyCodes: data.currencyCodes
  })
}

const store = {
  namespaced: true,
  state: defaultState,
  mutations: {
    [SET_STATE] (state, payload) {
      for (let key in payload)
        state[key] = payload[key];
    }
  },
  actions: {
    async lazilyPlaces({ state, commit }) {
      if (state.loadingPlaces) return;
      if (state.places) return;
      commit(SET_STATE, {loadingPlaces: true, loadingRegs: true});

      let rawData = await getPlaces();

      let lv12 = [];
      let kv = {};
      let frmData = [];
      for (let a of rawData) {
        let key = a.Code;
        let level = a.Level;
        let name = a.Name;
        let parent = a.ParentCode;

        if (key == '7700000000000' && level == 3) continue;
        else if (key == '7800000000000' && level == 3) continue;
        else if (key == '9200000000000' && level == 3) continue;

        let item = { key: JSON.stringify({ key, level }), name, parent, level };

        if (kv[key]) {
          if (kv[key].level > item.level) {
            kv[key] = item;
          }
        } else {
          kv[key] = item;
        }

        frmData.push(item);

        if (level === 1 || level === 2) {
          lv12.push({key, name, parent, level});
        }
      }

      for (let itm of frmData) {
        if (!hasValue(itm.parent)) continue;

        let po = kv[itm.parent];
        if (!po) itm.parent = undefined;
        else itm.parent = JSON.stringify({ key: itm.parent, level: po.level });
      }

      let places = flatDict(frmData);
      let regs = flatDict(lv12);

      commit(SET_STATE, {places, regs, loadingPlaces: false, loadingRegs: false})
    },
    async lazilyRegs({ dispatch }) {
      await dispatch('lazilyPlaces');
    },
    async lazilyPurchaseMethods({ state, commit }) {
      await loadDicts({ state, commit });
    },
    async lazilySections({ state, commit }) {
      await loadDicts({ state, commit });
    },
    async lazilyCurrencyCodes({ state, commit }) {
      await loadDicts({ state, commit });
    },
    async lazilyOkpd2({ state, commit }) {
      if (state.okpd2 || state.loadingOkpd2) return;
      commit(SET_STATE, {loadingOkpd2: true});
      let data = flatTree(await getOkpd2Json());
      commit(SET_STATE, {okpd2: data, loadingOkpd2: false})
    },
  }
};

export default store;
